// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { NEARMAP } from 'Features/order/OrderForm/Package/DataSource/dataSection';

// The tier every pricing read falls back to for an account that holds none of the company's rows
export const NO_SUBSCRIPTION_TIER = 'no subscription';

// The Nearmap Tier select's options (AUT-6630): Nearmap's imagery_providers rows, in the order served. Every imagery
// company has a "no subscription" row (AUT-5529), so the full list names that tier once per company.
export const nearmapTierOptions = (providers: IImageryProvider[] | null | undefined): IImageryProvider[] =>
  (providers || []).filter((provider) => provider.company === NEARMAP);

// What the select shows: the account's Nearmap row wherever it sits in its list; with none, Nearmap's no-subscription
// row — what the account is priced at; '' when there are no options or no such row, so the Select stays controlled.
export const nearmapTierValue = (orgProviderIds: string[] | null | undefined, options: IImageryProvider[]): string => {
  const held = (orgProviderIds || []).find((id) => options.some((option) => option._id === id));
  if (held) return held;
  return options.find((option) => option.name === NO_SUBSCRIPTION_TIER)?._id || '';
};
